import { // Travel & Adventure
IconAirplaneTakeOff, IconAlarmClock, IconAllBookmark, IconAmericanFootball, IconAnalytics, IconAnalyticsUp, IconAppleCat, IconArrow, IconAttachment, IconAward, IconBaby, IconBackpack, IconBackpack02, IconBadminton, IconBag, IconBalloon, IconBandage, IconBank, IconBaseball, IconBasketball, IconBasketball02, IconBathtub, IconBeach, IconBedSingle, IconBicycle, IconBicycleRider, IconBin, IconBinoculars, IconBitcoin, IconBloodBag, IconBoat, IconBodyMuscle, IconBookBookmark, IconBookClosed, IconBookEdit, IconBookEmpty, IconBookOpen, IconBoxingGlove, IconBrain, IconBrain02, // Career & Mission
IconBriefcase, // Hobbies & Creativity
IconBrush, IconBus, IconCake, // Reserved
IconCalendar, IconCalendar03, IconCalling, IconCamera, IconCandelier, IconCanvas, IconCar, IconCardiogram, // Nutrition & Health
IconCarrot, // Finances & Abundance
IconCash, IconCat, IconChatBubble, IconCheckmarkBadge, IconChemistry, IconChildParent, IconCloud, IconCloudRain, IconCoffee, IconComb, IconComment, IconComputer, IconConfetti, IconCreditCard, IconCrown, IconCurtains, IconDancing, IconDeliveryDelay, IconDesk, IconDie, IconDiploma, IconDirections, IconDiscountTag, IconDish, IconDishwasher, IconDog, IconDollar02, IconDoor, IconDrawingCompass, IconDropper, IconDrum, // Body & Fitness
IconDumbbell02, IconEar, IconEnergy, IconEraser, IconEuro, IconExternalCalendar, IconEye, IconFallingStar, IconFamily, IconFan, IconFastWind, IconFerrisWheel, IconFigure, IconFile, IconFilm, IconFilmSlate, IconFirstAidKit, IconFish, IconFolder, IconFootball, IconFuelStation, IconFullMoon, IconGamepad, IconGiftCard, IconGlasses, // Nature & Wildlife
IconGlobal, IconGlobe, IconGolfHole, IconGps, IconGraduationScroll, IconGroceryBasket, IconHammer, IconHandBag, IconHandPrayer, IconHanger, IconHeadphone, IconHeadphones, // Emotions & Well-being
IconHeartbreak, IconHold, IconHotBowl, IconHotDrink, IconHotel, IconHourglass, // Home & Environment
IconHouse, IconHumidity, IconIceHockey, IconIceSkating, IconIdea, IconImage, IconInboxUpload, IconInjection, IconInvoice, IconInvoice02, IconIron, IconKayak, IconKey, IconKeyboard, IconKnowledge, IconLadybug, IconLamp, IconLaptop, IconLargeSuitcase, IconLicenseDraft, IconLizard, IconLuggage, IconLungs, IconMagicWand, IconMail, IconMaps, IconMask, IconMasks, IconMath, IconMedal02, IconMedalFirstPlace, IconMedicalFile, IconMedicine, IconMedicineBottle, IconMic, IconMicrophoneStand, IconMicrowave, IconMoney, IconMoon, IconMortarboard, IconMotorbike, IconMountain, IconMovie, IconMusicNote, IconMusicNotesTwoEight, IconMusicalNotes, IconNaturalFood, IconNavigation, IconNews, IconNose, // Mind & Growth
IconNote, IconNotebook, IconOcean, IconOffice, IconOlympicTorch, IconOven, IconPaintBoard, IconPaintBrush04, IconPaintbrush, IconPainting, IconPan, IconParty, IconPawprint, IconPeaceSign, IconPenTool, IconPencil, IconPencilDraw, IconPencilEdit01, IconPencilEdit02, IconPersonLuggage, IconPersonWave, IconPhone, IconPhysics, IconPiano, IconPieChart, IconPieChartQuarter, IconPin, IconPinLocation, IconPlacemarker, IconPlaneTakeoff, IconPlant, IconPool, IconPound, IconPresent, IconPresentationBarChart, IconPrinter, IconPuzzle, IconRabbit, IconRaceFlag, IconRacingFlag, IconRain, IconRainDrop, IconRainbow, IconRainbowCloud, IconRefrigerator, IconRunningShoes, IconSchoolBell, IconScissors, IconScooter, IconSent, IconShell, IconShirt, IconShoppingBasket, IconShoppingCart, IconSignature, IconSink, IconSkippingRope, IconSmile, IconSnow, IconSofaSingle, IconSparkles, IconSquareLock, IconStarburst, IconStationery, IconStethoscope, IconStopWatch, IconStore, IconStore01, IconStroller, IconStudyLamp, IconSuitcase, IconSun, IconSunCloud, IconSunrise, IconSunset, IconSwimming, IconTShirt, IconTable, IconTableTennisBat, IconTag, IconTapeMeasure, IconTarget02, IconTaxes, IconTelescope, IconTelevision, IconTennisBall, IconTequila, IconTestTube, IconTheatre, IconThermometer, IconThumbsUp, IconTick, IconTicket, IconTicket01, IconToilet, IconTornado, IconTrain, IconTree, IconTrophy, IconTruck, IconTwoFigures, IconUmbrella, IconUncategorized, // Human & Communication
IconUser, IconUserFullView, IconUserGroup, IconUserGroupAlt, IconUserMultiple, IconUsers, IconVegetarianFood, IconVideo, IconVolleyball, IconWallet, IconWardrobe, IconWashingMachine, IconWaterBottle, IconWaterfallUp, IconWavingHand, IconWeight, IconWeightScale, IconWindSurf, IconWorkoutGymnastics, IconWorkoutRun, IconWorkoutStretching, IconYoga, IconZap } from '@/theme/icons';
import { SVGProps } from 'react';

type IconComponent = React.FunctionComponent<
  SVGProps<SVGSVGElement> & {
    title?: string | undefined;
  }
>;

type IconsProps = {
  [key: string]: IconComponent;
};

export type IconGroup = {
  id: string;
  label: string;
  selectorIcon: IconComponent;
  icons: IconsProps;
};

export const CATEGORY_COLORS = [
  '#FF4D4D',
  'orange.400',
  '#FF8080',
  '#FFC4A3',
  'rose.400',
  '#F48FB1',
  '#F2C7F9',
  'magenta.400',
  'purple.400',
  '#D1A4FC',
  'blue.400',
  '#AFCBFA',
  '#8AD4CC',
  'teal.400',
  'lime.400',
  '#AED581',
  'yellow.400',
  '#FFF176',
];

// Icon groups organized by category with selector icons
export const CATEGORY_ICON_GROUPS: IconGroup[] = [
  {
    id: 'mind-growth',
    label: 'Mind & Growth',
    selectorIcon: IconBookClosed,
    icons: {
      bookClosed: IconBookClosed,
      bookOpen: IconBookOpen,
      bookEdit: IconBookEdit,
      idea: IconIdea,
      brain: IconBrain,
      note: IconNote,
      notebook: IconNotebook,
      eraser: IconEraser,
      pencil: IconPencil,
      pencilEdit01: IconPencilEdit01,
      penTool: IconPenTool,
      knowledge: IconKnowledge,
      target02: IconTarget02,
      hourglass: IconHourglass,
      graduationScroll: IconGraduationScroll,
      diploma: IconDiploma,
      mortarBoard: IconMortarboard,
      globe: IconGlobe,
      chemistry: IconChemistry,
      math: IconMath,
      telescope: IconTelescope,
      physics: IconPhysics,
      bookBookmark: IconBookBookmark,
      stationery: IconStationery,
      testTube: IconTestTube,
      canvas: IconCanvas,
      backpack02: IconBackpack02,
      desk: IconDesk,
      drawingCompass: IconDrawingCompass,
      glasses: IconGlasses,
      studyLamp: IconStudyLamp,
      schoolBell: IconSchoolBell,
      puzzle: IconPuzzle,
    },
  },
  {
    id: 'body-fitness',
    label: 'Body & Fitness',
    selectorIcon: IconDumbbell02,
    icons: {
      dumbbell02: IconDumbbell02,
      trophy: IconTrophy,
      award: IconAward,
      medal: IconMedal02,
      medalFirstPlace: IconMedalFirstPlace,
      bodyMuscle: IconBodyMuscle,
      boxingGlove: IconBoxingGlove,
      swimming: IconSwimming,
      pool: IconPool,
      runningShoes: IconRunningShoes,
      skippingRope: IconSkippingRope,
      tapeMeasure: IconTapeMeasure,
      weightScale: IconWeightScale,
      workoutRun: IconWorkoutRun,
      workoutStretching: IconWorkoutStretching,
      workoutGymnastics: IconWorkoutGymnastics,
      americanFootball: IconAmericanFootball,
      badminton: IconBadminton,
      baseball: IconBaseball,
      tableTennisBat: IconTableTennisBat,
      tennisBall: IconTennisBall,
      basketball02: IconBasketball02,
      football: IconFootball,
      volleyball: IconVolleyball,
      bicycle: IconBicycle,
      golfHole: IconGolfHole,
      iceHockey: IconIceHockey,
      iceSkating: IconIceSkating,
      kayak: IconKayak,
      olympicTorch: IconOlympicTorch,
      raceFlag: IconRaceFlag,
      racingFlag: IconRacingFlag,
      windSurf: IconWindSurf,
      energy: IconEnergy,
    },
  },
  {
    id: 'nutrition-health',
    label: 'Nutrition & Health',
    selectorIcon: IconCarrot,
    icons: {
      carrot: IconCarrot,
      coffee: IconCoffee,
      waterBottle: IconWaterBottle,
      vegetarianFood: IconVegetarianFood,
      dish: IconDish,
      pan: IconPan,
      medicine: IconMedicine,
      thermometer: IconThermometer,
      dropper: IconDropper,
      injection: IconInjection,
      firstAidKit: IconFirstAidKit,
      stethoscope: IconStethoscope,
      mask: IconMask,
      bloodBag: IconBloodBag,
      cardiogram: IconCardiogram,
      medicineBottle: IconMedicineBottle,
      bandage: IconBandage,
      medicalFile: IconMedicalFile,
    },
  },
  {
    id: 'emotions-wellbeing',
    label: 'Emotions & Well-being',
    selectorIcon: IconHeartbreak,
    icons: {
      heartbreak: IconHeartbreak,
      smile: IconSmile,
      brain02: IconBrain02,
      sparkles: IconSparkles,
      fallingStar: IconFallingStar,
      yoga: IconYoga,
      naturalFood: IconNaturalFood,
      starBurst: IconStarburst,
      handPrayer: IconHandPrayer,
      peaceSign: IconPeaceSign,
    },
  },
  {
    id: 'human-communication',
    label: 'Human & Communication',
    selectorIcon: IconUser,
    icons: {
      user: IconUser,
      userFullView: IconUserFullView,
      userMultiple: IconUserMultiple,
      userGroupAlt: IconUserGroupAlt,
      figure: IconFigure,
      dancing: IconDancing,
      twoFigures: IconTwoFigures,
      family: IconFamily,
      childParent: IconChildParent,
      baby: IconBaby,
      ear: IconEar,
      nose: IconNose,
      eye: IconEye,
      lungs: IconLungs,
      thumbsUp: IconThumbsUp,
      hold: IconHold,
      wavingHand: IconWavingHand,
      comment: IconComment,
      personWave: IconPersonWave,
    },
  },
  {
    id: 'career-mission',
    label: 'Career & Mission',
    selectorIcon: IconBriefcase,
    icons: {
      briefcase: IconBriefcase,
      pencilEdit02: IconPencilEdit02,
      folder: IconFolder,
      computer: IconComputer,
      laptop: IconLaptop,
      phone: IconPhone,
      attachment: IconAttachment,
      analytics: IconAnalytics,
      analyticsUp: IconAnalyticsUp,
      file: IconFile,
      licenseDraft: IconLicenseDraft,
      pin: IconPin,
      alarmClock: IconAlarmClock,
      calendar03: IconCalendar03,
      stopWatch: IconStopWatch,
      presentationBarChart: IconPresentationBarChart,
      allBookmark: IconAllBookmark,
      tag: IconTag,
      mail: IconMail,
      inboxUpload: IconInboxUpload,
      sent: IconSent,
      calling: IconCalling,
      news: IconNews,
      printer: IconPrinter,
      keyboard: IconKeyboard,
      checkmarkBadge: IconCheckmarkBadge,
      tick: IconTick,
      office: IconOffice,
      headphones: IconHeadphones,
      mic: IconMic,
      signature: IconSignature,
    },
  },
  {
    id: 'finances-abundance',
    label: 'Finances & Abundance',
    selectorIcon: IconCash,
    icons: {
      cash: IconCash,
      bank: IconBank,
      store01: IconStore01,
      taxes: IconTaxes,
      bitcoin: IconBitcoin,
      creditCard: IconCreditCard,
      dollar02: IconDollar02,
      euro: IconEuro,
      pound: IconPound,
      invoice: IconInvoice,
      pieChart: IconPieChart,
      wallet: IconWallet,
      waterfallUp: IconWaterfallUp,
      shoppingCart: IconShoppingCart,
      shoppingBasket: IconShoppingBasket,
      invoice02: IconInvoice02,
      deliveryDelay: IconDeliveryDelay,
      giftCard: IconGiftCard,
      discountTag: IconDiscountTag,
      present: IconPresent,
    },
  },
  {
    id: 'hobbies-creativity',
    label: 'Hobbies & Creativity',
    selectorIcon: IconBrush,
    icons: {
      brush: IconBrush,
      paintBoard: IconPaintBoard,
      paintBrush04: IconPaintBrush04,
      musicNote: IconMusicNote,
      musicalNotes: IconMusicalNotes,
      theatre: IconTheatre,
      filmSlate: IconFilmSlate,
      film: IconFilm,
      television: IconTelevision,
      video: IconVideo,
      party: IconParty,
      magicWand: IconMagicWand,
      cake: IconCake,
      crown: IconCrown,
      ticket01: IconTicket01,
      balloon: IconBalloon,
      gamepad: IconGamepad,
      camera: IconCamera,
      piano: IconPiano,
      image: IconImage,
    },
  },
  {
    id: 'travel-adventure',
    label: 'Travel & Adventure',
    selectorIcon: IconAirplaneTakeOff,
    icons: {
      airplaneTakeOff: IconAirplaneTakeOff,
      car: IconCar,
      boat: IconBoat,
      bus: IconBus,
      motorbike: IconMotorbike,
      scooter: IconScooter,
      fuelStation: IconFuelStation,
      train: IconTrain,
      truck: IconTruck,
      beach: IconBeach,
      hotel: IconHotel,
      maps: IconMaps,
      navigation: IconNavigation,
      pinLocation: IconPinLocation,
      directions: IconDirections,
      personLuggage: IconPersonLuggage,
      luggage: IconLuggage,
      suitcase: IconSuitcase,
      binoculars: IconBinoculars,
      gps: IconGps,
    },
  },
  {
    id: 'home-environment',
    label: 'Home & Environment',
    selectorIcon: IconHouse,
    icons: {
      house: IconHouse,
      door: IconDoor,
      stroller: IconStroller,
      bin: IconBin,
      bathtub: IconBathtub,
      sink: IconSink,
      toilet: IconToilet,
      bedSingle: IconBedSingle,
      sofaSingle: IconSofaSingle,
      wardrobe: IconWardrobe,
      table: IconTable,
      fan: IconFan,
      candelier: IconCandelier,
      lamp: IconLamp,
      curtains: IconCurtains,
      washingMachine: IconWashingMachine,
      dishwasher: IconDishwasher,
      refrigerator: IconRefrigerator,
      oven: IconOven,
      microwave: IconMicrowave,
      shirt: IconShirt,
      umbrella: IconUmbrella,
      handBag: IconHandBag,
      comb: IconComb,
      hanger: IconHanger,
      bag: IconBag,
      squareLock: IconSquareLock,
      key: IconKey,
      scissors: IconScissors,
      hammer: IconHammer,
    },
  },
  {
    id: 'nature-wildlife',
    label: 'Nature & Wildlife',
    selectorIcon: IconGlobal,
    icons: {
      global: IconGlobal,
      sun: IconSun,
      sunrise: IconSunrise,
      sunset: IconSunset,
      cloud: IconCloud,
      sunCloud: IconSunCloud,
      cloudRain: IconCloudRain,
      fastWind: IconFastWind,
      humidity: IconHumidity,
      fullMoon: IconFullMoon,
      moon: IconMoon,
      rain: IconRain,
      rainDrop: IconRainDrop,
      rainbow: IconRainbow,
      rainbowCloud: IconRainbowCloud,
      snow: IconSnow,
      tornado: IconTornado,
      plant: IconPlant,
      dog: IconDog,
      cat: IconCat,
      lizard: IconLizard,
      ladybug: IconLadybug,
      rabbit: IconRabbit,
      shell: IconShell,
      fish: IconFish,
      pawprint: IconPawprint,
      mountain: IconMountain,
      tree: IconTree,
      ocean: IconOcean,
      zap: IconZap,
    },
  },
];

// Flat map of all icons for backwards compatibility
export const CATEGORIES_ICONS: IconsProps = {
  // All grouped icons
  ...CATEGORY_ICON_GROUPS.reduce((acc, group) => ({ ...acc, ...group.icons }), {}),
  // Legacy/Reserved icons
  medal: IconMedal02,
  apple: IconAppleCat,
  dollar: IconDollar02,
  note: IconNote,
  user: IconUser,
  calendar: IconCalendar,
  pencildraw: IconPencilDraw,
  ferriswheel: IconFerrisWheel,
  tequila: IconTequila,
  stroller: IconStroller,
  grocerybasket: IconGroceryBasket,
  masks: IconMasks,
  appleCat: IconBrush,
  backpack02: IconBackpack02,
  external: IconExternalCalendar,
  uncategorized: IconUncategorized,
  work: IconBriefcase,
  home: IconHouse,
  book: IconBookOpen,
  users: IconUsers,
  heart: IconHeartbreak,
  meeting: IconCalendar03,
  health: IconStethoscope,
  folder: IconFolder,
  arrow: IconArrow,
  weight: IconWeight,
  mountain: IconMountain,
  plant: IconPlant,
  dog: IconDog,
  idea: IconIdea,
  suitcase: IconLargeSuitcase,
  placemarker: IconPlacemarker,
  store: IconStore,
  tshirt: IconTShirt,
  chatbubble: IconChatBubble,
  bookempty: IconBookEmpty,
  backpack: IconBackpack,
  luggage: IconLuggage,
  money: IconMoney,
  piechartquarter: IconPieChartQuarter,
  musicnotestwoeight: IconMusicNotesTwoEight,
  drum: IconDrum,
  magicwand: IconMagicWand,
  planetakeoff: IconPlaneTakeoff,
  bicyclerider: IconBicycleRider,
  painting: IconPainting,
  headphone: IconHeadphone,
  television: IconTelevision,
  movie: IconMovie,
  microphonestand: IconMicrophoneStand,
  boat: IconBoat,
  paintbrush: IconPaintbrush,
  confetti: IconConfetti,
  iron: IconIron,
  die: IconDie,
  stethoscope: IconStethoscope,
  ticket: IconTicket,
  hotdrink: IconHotDrink,
  hotbowl: IconHotBowl,
  basketball: IconBasketball,
  laptop: IconLaptop,
  usergroup: IconUserGroup,
};

// Helper function to get icon with safe fallback
export const getCategoryIcon = (iconKey: string | null | undefined): IconComponent => {
  if (!iconKey) {
    return CATEGORIES_ICONS.uncategorized || IconUncategorized;
  }
  return CATEGORIES_ICONS[iconKey] || CATEGORIES_ICONS.uncategorized || IconUncategorized;
};